export default theme => ({
    root: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: theme.height.topBar,
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        backgroundColor: theme.palette.common.white,
        borderBottom: `1px solid ${theme.palette.border}`,
        zIndex: theme.zIndex.appBar,
    },
    menuButton: {
        color: theme.palette.tertiary.main,
    },
});
